<template>
  <div class="cashier-modal-overlay" @click.self="$emit('close')">
    <div class="cashier-modal" @click.stop>
      <div class="cashier-modal__header">
        <h5>{{ isEditMode ? 'Редагування касира' : 'Новий касир' }}</h5>
        <button type="button" class="close-btn" @click="$emit('close')">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="cashier-modal__body">
        <b-form-group label="Ключ ліцензії каси" label-cols-sm="5" label-size="sm" class="mb-3">
          <b-form-input
            v-model="form.license_key"
            placeholder="Введіть ключ ліцензії"
            :state="errors.license_key ? false : null"
          />
          <b-form-invalid-feedback>{{ errors.license_key }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Логін" label-cols-sm="5" label-size="sm" class="mb-3">
          <b-form-input
            v-model="form.login"
            placeholder="email@example.com"
            :state="errors.login ? false : null"
          />
          <b-form-invalid-feedback>{{ errors.login }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Пароль" label-cols-sm="5" label-size="sm" class="mb-3">
          <b-form-input
            v-model="form.password"
            type="password"
            :placeholder="isEditMode ? '(залиште порожнім щоб не змінювати)' : 'Введіть пароль'"
            :state="errors.password ? false : null"
          />
          <b-form-invalid-feedback>{{ errors.password }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="ПІБ касира" label-cols-sm="5" label-size="sm" class="mb-3">
          <b-form-input
            v-model="form.full_name"
            placeholder="Іванов Іван Іванович"
            :state="errors.full_name ? false : null"
          />
          <b-form-invalid-feedback>{{ errors.full_name }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Активний" label-cols-sm="5" label-size="sm" class="mb-3">
          <toggle-button
            v-model="form.is_active"
            :margin="0"
            :width="40"
            :height="20"
            color="#94D974"
          />
        </b-form-group>

        <b-form-group label="Авто зміни" label-cols-sm="5" label-size="sm" class="mb-3">
          <toggle-button
            v-model="form.auto_shift"
            :margin="0"
            :width="40"
            :height="20"
            color="#94D974"
          />
          <small class="text-muted d-block mt-1">Автоматичне відкриття/закриття змін о 00:10/23:50</small>
        </b-form-group>

        <b-form-group label="Режим роботи" label-cols-sm="5" label-size="sm" class="mb-3">
          <b-button-group size="sm">
            <b-button
              :variant="form.mode === 'sender' ? 'primary' : 'outline-secondary'"
              @click="$emit('set-mode', 'sender')"
              title="Відправник НП"
            >
              <i class="fa fa-user mr-1"></i>
              Відправник
            </b-button>
            <b-button
              :variant="form.mode === 'department' ? 'primary' : 'outline-secondary'"
              @click="$emit('set-mode', 'department')"
              title="Відділ"
            >
              <i class="fa fa-building mr-1"></i>
              Відділ
            </b-button>
          </b-button-group>
        </b-form-group>

        <b-form-group
          v-if="isEditMode && form.mode === 'sender'"
          label="Контрагенти НП"
          label-cols-sm="5"
          label-size="sm"
          class="mb-3"
        >
          <div v-if="counterpartiesLoading" class="text-muted small">
            <i class="fa fa-spinner fa-spin mr-1"></i> Завантаження...
          </div>
          <v-select
            v-else
            v-model="form.counterparty_ids"
            :options="availableCounterparties"
            :reduce="(i) => i.id"
            label="name"
            multiple
            placeholder="Оберіть контрагентів"
            class="counterparties-select"
          >
            <template #option="{ name }">
              <span>{{ name }}</span>
            </template>
            <template #selected-option="{ name }">
              <span>{{ name }}</span>
            </template>
            <template #no-options>
              <span>Немає доступних Відправників</span>
            </template>
          </v-select>
          <small class="text-muted d-block mt-1">
            {{ form.mode === 'sender' ? 'Чеки будуть автоматично вибиватись для замовлень цих відправників' : 'Чеки будуть  вибиватись для замовлень цих відділів' }}
          </small>
        </b-form-group>

        <b-form-group
          v-if="isEditMode && form.mode === 'department'"
          label="Відділення"
          label-cols-sm="5"
          label-size="sm"
          class="mb-3"
        >
          <div v-if="departmentsLoading" class="text-muted small">
            <i class="fa fa-spinner fa-spin mr-1"></i> Завантаження...
          </div>
          <v-select
            v-else
            v-model="form.department_ids"
            :options="departmentsList"
            :reduce="(i) => i.id"
            label="title"
            multiple
            placeholder="Оберіть відділення"
            class="counterparties-select"
          >
            <template #option="{ title }">
              <span>{{ title }}</span>
            </template>
            <template #selected-option="{ title }">
              <span>{{ title }}</span>
            </template>
            <template #no-options>
              <span>Немає доступних відділень</span>
            </template>
          </v-select>
          <small class="text-muted d-block mt-1">
            Чеки будуть автоматично вибиватись для замовлень цих відділів
          </small>
        </b-form-group>

        <div v-if="!isEditMode" class="mb-3 text-muted small">
          <i class="fa fa-info-circle mr-1"></i>
          Прив'язки можна налаштувати після створення касира
        </div>
      </div>
      <div class="cashier-modal__footer">
        <b-button variant="secondary" size="sm" @click="$emit('close')" class="mr-2">
          Скасувати
        </b-button>
        <b-button variant="primary" size="sm" @click="$emit('save')" :disabled="isSaving">
          <i v-if="isSaving" class="fa fa-spinner fa-spin mr-1"></i>
          {{ isEditMode ? 'Зберегти' : 'Додати' }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CashierFormModal',
  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
    counterpartiesLoading: {
      type: Boolean,
      default: false,
    },
    availableCounterparties: {
      type: Array,
      default: () => [],
    },
    departmentsLoading: {
      type: Boolean,
      default: false,
    },
    departmentsList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.cashier-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1060;
}

.cashier-modal {
  background: #fff;
  border-radius: 8px;
  width: 500px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid #dee2e6;
    background: #f8f9fa;

    h5 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
    }

    .close-btn {
      border: none;
      background: none;
      font-size: 18px;
      color: #6c757d;
      cursor: pointer;
      padding: 0;
      line-height: 1;

      &:hover {
        color: #343a40;
      }
    }
  }

  &__body {
    padding: 16px;
    overflow-y: auto;
    max-height: calc(90vh - 120px);
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    padding: 12px 16px;
    border-top: 1px solid #dee2e6;
    background: #f8f9fa;
  }
}

.counterparties-select {
  ::v-deep .vs__dropdown-toggle {
    min-height: 32px;
  }

  ::v-deep .vs__selected {
    background: #e9ecef;
    border: none;
    font-size: 12px;
    padding: 2px 6px;
    margin: 2px;
  }

  ::v-deep .vs__deselect {
    margin-left: 4px;
  }
}

::v-deep .form-group {
  label {
    text-align: right;
    padding-right: 1rem;
    font-size: 13px;
  }
}
</style>
